module.exports = __webpack_public_path__ + "img/1557614102754435073.57eb7f90.png";